import { Heading } from '@cinch-labs/design-system'
import styles from './table-section.module.css'
import {
  SbBlokData,
  StoryBlokRichText,
  StoryblokTable,
} from '@cinch-nx/data-storyblok'
import { StoryblokRendererV2 as StoryblokRenderer } from '@cinch-nx/storyblok-utils'
import { toTableSbBlokData } from '@cinch-nx/storyblok-utils'
import { servicingStoryblokComponents } from '../data/storyblok-renderer-map'
import { renderWithResolver } from '@cinch-nx/landing-ui-shared'
import { useMemo } from 'react'
import { ScrollableContainer } from '../../design-system/scrollable-container'

export interface TableSectionProps {
  heading?: string
  description?: StoryBlokRichText
  table?: SbBlokData[] | StoryblokTable
}

export const TableSection = ({
  heading,
  description,
  table,
}: TableSectionProps) => {
  const tableBlock = useMemo(() => toTableSbBlokData(table), [table])

  return (
    <section className={styles.section}>
      {heading && (
        <Heading element="h2" className={styles.heading}>
          {heading}
        </Heading>
      )}

      {description && (
        <div className={styles.description}>
          {renderWithResolver(description)}
        </div>
      )}

      {tableBlock.length > 0 && (
        <ScrollableContainer description="scroll to view table">
          <div className={styles.tableWrapper}>
            <StoryblokRenderer
              block={tableBlock}
              components={servicingStoryblokComponents}
            />
          </div>
        </ScrollableContainer>
      )}
    </section>
  )
}

export default TableSection
